import { Check } from "lucide-react";

export function PraticaProgress({ steps = [], compact = false }) {
  const total = steps.length;
  const done = steps.filter((s) => s.completato).length;
  const pct = total ? Math.round((done / total) * 100) : 0;
  const currentIdx = steps.findIndex((s) => !s.completato);

  if (compact) {
    return (
      <div className="flex items-center gap-2 min-w-[120px]" data-testid="pratica-progress-compact">
        <div className="flex-1 h-1.5 bg-[#1A2B4A]/10 rounded-full overflow-hidden">
          <div className="h-full bg-[#C9A84C] rounded-full transition-all duration-500" style={{ width: `${pct}%` }} />
        </div>
        <span className="text-[11px] text-[#4a5568] tabular-nums w-8 text-right">{pct}%</span>
      </div>
    );
  }

  return (
    <div className="bg-white border border-[#1A2B4A]/10 rounded-lg p-4 shadow-sm" data-testid="pratica-progress">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-xl font-semibold tracking-tight text-[#1A2B4A]">Avanzamento pratica</h3>
        <span className="text-sm text-[#4a5568]">{done}/{total} step · <span className="text-[#C9A84C] font-semibold">{pct}%</span></span>
      </div>
      <div className="h-2 bg-[#1A2B4A]/10 rounded-full overflow-hidden mb-6">
        <div className="h-full bg-[#C9A84C] rounded-full transition-all duration-700" style={{ width: `${pct}%` }} />
      </div>
      {total === 0 ? (
        <p className="text-sm text-[#4a5568]">Nessuno step definito per questa pratica.</p>
      ) : (
        <div className="flex items-start overflow-x-auto pb-2">
          {steps.map((s, i) => {
            const state = s.completato ? "done" : i === currentIdx ? "current" : "todo";
            return (
              <div key={`${i}-${s.nome}`} className="flex-1 min-w-[92px] flex flex-col items-center relative" data-testid={`progress-node-${i}`}>
                {i < total - 1 && (
                  <div className={`absolute top-4 left-1/2 w-full h-0.5 ${s.completato ? "bg-[#C9A84C]" : "bg-[#1A2B4A]/15"}`} />
                )}
                <div className={`relative z-10 w-8 h-8 rounded-full flex items-center justify-center border-2 transition-all ${
                  state === "done" ? "bg-[#C9A84C] border-[#C9A84C] text-white" :
                  state === "current" ? "bg-white border-[#C9A84C] text-[#C9A84C] ring-4 ring-[#C9A84C]/20" :
                  "bg-white border-[#1A2B4A]/20 text-[#1A2B4A]/40"}`}>
                  {state === "done" ? <Check className="w-4 h-4" /> : <span className="text-xs font-semibold">{i + 1}</span>}
                </div>
                <span className={`mt-2 text-[11px] text-center leading-tight px-1 ${state === "todo" ? "text-[#4a5568]" : "text-[#1A2B4A] font-medium"}`}>
                  {s.nome}
                </span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
